export default "__VITE_ASSET__47cb9dda__"